import { Hero } from "@/components/home/Hero";
import { PathCards, Why, FounderSection, HomeOffice, ServicesOverview, Faq } from "@/components/home/Sections";
import { DiscoveryBand, Marquee } from "@/components/site/Blocks";

// Testimonials section is hidden until verified client feedback is available.
export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <PathCards />
      <Why />
      <FounderSection />
      <HomeOffice />
      <ServicesOverview />
      <Faq />
      <DiscoveryBand />
    </>
  );
}
